import * as React from 'react'
import { FC, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useGetCampaignsOnMount } from '@user/store/campaigns/hooks/useGetCampaignsOnMount'
import { selectAllCampaigns } from '@user/store/campaigns/slice'
import { IOption, IProviderProps } from '@user/components/Filters'

export const CampaignProvider: FC<IProviderProps> = ({ render }) => {
  const status = useGetCampaignsOnMount()
  const campaigns = useSelector(selectAllCampaigns)

  const data = useMemo(
    () => campaigns.map<IOption>((c) => ({ label: c.name, value: c.id })),
    [campaigns],
  )

  return <>{render(data, status === 'pending')}</>
}
CampaignProvider.displayName = 'CampaignProvider'
